import React, { useState, useEffect } from "react";
//* Material UI MUI
import { Box, Fade } from "@mui/material";
import { RHFCheckboxGroup, NotificationCard } from "@arp/react-ndbx";
import { useWatch } from "react-hook-form";

export default function CheckboxNotification({ ...props }) {
	const {
		dataSetItem,
		tooltips,
		fieldName,
		label = "",
		options = [],
		defaultValue = [],
		notificationItems,
		showCheckboxList = false,
		showTooltip = false,
		fadeTimer = 500,
		errorVariant = false, //* used to change the variant to an error variant
		clearForm = false,
		methods,
	} = { ...props };

	const { clearErrors, control } = { ...methods };
	const [showNotification, setShowNotification] = useState(false);
	const [listOptions, setListOptions] = useState([]);
	// const [listDefaultValues, setListDefaultValues] = useState([]);

	const [notificationCard, setNotificationCard] = useState({});
	const checkValues = options.filter((item) => item.check === true);

	// ****************************************************************
	const checkListWatch = useWatch({
		control,
		name: fieldName,
	});

	const setNotifications = () => {
		if (checkValues.length === 0) return;

		let checkName = "";
		let found = false;
		for (const item of checkValues) {
			if (checkListWatch && checkListWatch?.includes(item.value)) {
				checkName = item.value;
				found = true;
			}
		}

		found === true ? setShowNotification(true) : setShowNotification(false);

		for (const [key, value] of Object.entries(notificationItems)) {
			if (found && value?.name?.charAt(0) === checkName) {
				//* this has to match the value in the list item.
				setNotificationCard(key);
			}
		}
	};

	useEffect(() => {
		setNotifications();
	}, [checkListWatch]);

	//****** Set or rest notifications */

	useEffect(() => {
		setListOptions(options);
		// setListDefaultValues(defaultValue);
	}, []);

	useEffect(() => {
		setNotifications();
	}, [listOptions]);

	//----------------------------------------------------------------

	useEffect(() => {
		const checkFormValue = async () => {
			if (clearForm === true) {
				// Clear  errors and hide notifications
				await clearErrors(fieldName);
				setShowNotification(false);

				//  Uncheck all the items.
				// defaultValue = [];
			}
		};

		checkFormValue();
	}, [clearForm]);

	//----------------------------------------------------------------

	return (
		<Box
			sx={{
				outline: "0px solid green",
				alignContent: "right",
				alignItems: "right",
				minWidth: "100%",
			}}
		>
			<Fade in={showCheckboxList === true} timeout={fadeTimer}>
				<Box>
					<RHFCheckboxGroup
						name={fieldName}
						label={label}
						row={false}
						options={options}
						defaultValue={clearForm === true ? [] : defaultValue}
						clearForm={clearForm}
					/>
				</Box>
			</Fade>
			<Box
				sx={{
					outline: "0px solid black",
					mt: 1,
					ml: "0px !important",
					display: showNotification === true ? "flex" : "none",
					width: "100%",
				}}
			>
				<Fade in={showNotification === true} timeout={fadeTimer}>
					<Box sx={{ width: "100%" }}>
						<NotificationCard
							cardType={notificationItems[notificationCard]?.cardType}
							title={notificationItems[notificationCard]?.title}
							message={notificationItems[notificationCard]?.message}
							additionalText={
								notificationItems[notificationCard]?.additionalText
							}
							sx={{ minWidth: "100%" }}
						/>
					</Box>
				</Fade>
			</Box>
		</Box>
	);
}
